export class PlanTarget {
    public idHeader: string;
    public lastYearVolumeBaseLine: number;
    public lastYearVolumePromo: number;
    public totalVolumeTons: number;
    public totalVolumeEuroDurance: number;
    public totalVolumeYearBefore: number;
    public totalGifts: number;
    public avgGiftCost: number;
    public costPPE: number;
    public incidenceKg: number;
    public incidenceLiter: number;
    public incidenceEuro: number;
    public budgetIncidence: number;
    public notes: string;
    public mrkHeadNotes: string;
    public status: number;
    public productionConfirmation: string;
    public countryManagerEndorsement: string;
    public currentVersion: [];
    public statusDescription: string;
    public grossProfit: number;
    public isImported: boolean;

    constructor(
        idHeader?: string,
        lastYearVolumeBaseLine?: number,
        lastYearVolumePromo?: number,
        totalVolumeTons?: number,
        totalVolumeEuroDurance?: number,
        totalVolumeYearBefore?: number,
        totalGifts?: number,
        avgGiftCost?: number,
        costPPE?: number,
        incidenceKg?: number,
        incidenceLiter?: number,
        incidenceEuro?: number,
        budgetIncidence?: number,
        notes?: string,
        mrkHeadNotes?: string,
        status?: number,
        productionConfirmation?: string,
        countryManagerEndorsement?: string,
        statusDescription?: string,
        groosProfit?: number,
        currentVersion?: []
      ) {
        this.idHeader = idHeader;
        this.lastYearVolumeBaseLine = lastYearVolumeBaseLine;
        this.lastYearVolumePromo = lastYearVolumePromo;
        this.totalVolumeTons = totalVolumeTons;
        this.totalVolumeEuroDurance = totalVolumeEuroDurance;
        this.totalVolumeYearBefore = totalVolumeYearBefore;
        this.totalGifts = totalGifts;
        this.avgGiftCost = avgGiftCost;
        this.costPPE = costPPE;
        this.incidenceKg = incidenceKg;
        this.incidenceLiter = incidenceLiter;
        this.incidenceEuro = incidenceEuro;
        this.budgetIncidence = budgetIncidence;
        this.notes = notes;
        this.mrkHeadNotes = mrkHeadNotes;
        this.status = status;
        this.productionConfirmation = productionConfirmation;
        this.countryManagerEndorsement = countryManagerEndorsement;
        this.statusDescription = statusDescription;
        this.grossProfit = groosProfit;
        this.currentVersion = currentVersion;
      }
}